import React, { Component } from "react"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogActions from "@mui/material/DialogActions"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import LoadingButton from "@mui/lab/LoadingButton"
import Grow from "@mui/material/Grow"
import CircularProgress from "@mui/material/CircularProgress"
import { withTranslation } from "react-i18next"
import queryStringify from "querystringify"

export default withTranslation()(
  class CreateRoomDialog extends Component {
    state = { name: "", nameEmpty: null, nameError: null, loading: false }

    createRoom = async (experience, company) => {
      const { close, t, addRoom } = this.props

      this.setState({ loading: true })

      await fetch(
        `${
          process.env.REACT_APP_SERVER_URL
        }/experiences/${experience}/rooms?password=${localStorage.getItem(
          "password"
        )}&company=${company}`,
        {
          method: "POST",
          headers: {},
        }
      )
        .then((response) => {
          response.json().then((room) => addRoom(room))

          close()
        })
        .catch((err) => {
          this.setState({ nameError: t`Error` })
        })

      this.setState({ loading: false })
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.open && !this.props.open) {
        this.setState({
          name: "",
          nameEmpty: null,
          nameError: null,
          loading: false,
        })
      }
    }

    render() {
      const { open, close, t } = this.props
      const { name, nameEmpty, nameError, loading } = this.state

      return (
        <Dialog
          open={open}
          onClose={close}
          TransitionComponent={Grow}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            className="notSelectable"
            style={{ fontWeight: 600 }}
          >{t`Create a new room`}</DialogTitle>
          <DialogContent style={{ paddingBottom: 0 }}>
            <DialogContentText>
              <TextField
                fullWidth
                label={t`Company name`}
                variant="outlined"
                style={{ textTransform: "none" }}
                margin="normal"
                value={name}
                error={nameEmpty || nameError}
                helperText={
                  nameEmpty ? t`This field is required` : nameError || " "
                }
                onKeyPress={(event) => {
                  if (event.key === "Enter" && name && !nameError && !loading) {
                    this.createRoom(
                      queryStringify.parse(window.location.search).experience,
                      name
                    )
                  }
                }}
                onChange={(event) =>
                  this.setState({
                    name: event.target.value,
                    nameEmpty: event.target.value.replace(/\s/g, "") === "",
                    nameError: "",
                  })
                }
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={close}>{t`Close`}</Button>
            <LoadingButton
              loading={loading}
              loadingIndicator={<CircularProgress size={16} />}
              color="primary"
              style={{ fontWeight: 600 }}
              disabled={!name || nameError}
              onClick={() => {
                this.createRoom(
                  queryStringify.parse(window.location.search).experience,
                  name
                )
              }}
            >{t`Create`}</LoadingButton>
          </DialogActions>
        </Dialog>
      )
    }
  }
)
